import { render, staticRenderFns } from "./ServicesView.vue?vue&type=template&id=6ffc9c27&scoped=true&"
import script from "./ServicesView.vue?vue&type=script&lang=js&"
export * from "./ServicesView.vue?vue&type=script&lang=js&"
import style0 from "./ServicesView.vue?vue&type=style&index=0&id=6ffc9c27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffc9c27",
  null
  
)

export default component.exports